import React from 'react'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'underscore';
import { getDetailInpatientClaimBySysAdmin, getClaimOptions, getBankOptions, editInpatientClaimBySysAdmin } from '../../../actions'
import { Button, Grid, Divider, Segment, Header, Input, Message } from 'semantic-ui-react';
import { Formik, Form, Field, FieldArray } from 'formik';
import moment from 'moment';
import FormsInputsNumber from '../../../component/forms/inputs/number/forms_inputs_number';
import FormsInputDropdown from '../../../component/forms/inputs/dropdown/index';
import BankUtility from "../../../utils/bankUtility/BankUtility";
import { USER_ROLES, USER_TYPE, CLAIM_STATUS } from "../../../constants";
import CommonUtility from "../../../utils/CommonUtility";
import FormsInputsText from '../../forms/inputs/text/forms_inputs_text';

class InpatientViewImbursement extends React.Component {

    state = {
        successSubmit: null,
        errorMsg: null
    }

    componentDidMount() {
        this.getClaimData();
    }

    getClaimData(){
        if (this.props.user.accessToken) {

            // Get user ID
            const queryString = new URLSearchParams(this.props.history.location.search);
            const _id = queryString.get("_id");

            // Get Inpatient Detail
            this.props.getDetailInpatientClaimBySysAdmin(this.props.user.accessToken, { _id });
        }
    }

    renderSubmitResult() {
        if (this.state.successSubmit === true) {
            return (
                <Message positive>
                    <Message.Header>Data Updated Successfully!</Message.Header>
                </Message>
            );
        }
        if (this.state.successSubmit === false) {
            return (
                <Message negative>
                    <Message.Header>We're sorry - there was an issue</Message.Header>
                    <p>{this.state.errorMsg}</p>
                </Message>
            );
        }
    }

    editClaim(values, actions){
        try{
            
            this.setState({ ...this.state, successSubmit: undefined, successMsg: '', errorMsg: '' });
            
            let accessToken = this.props.user.accessToken;
            let dataToSend = {
                _id : values._id,
                claimRetry: 0
            }

            this.props.editInpatientClaimBySysAdmin(accessToken, dataToSend, 
                (success, error) => { 
                    actions.setSubmitting(false); 
                    if(success){
                        this.setState({ ...this.state, successSubmit: true, errorMsg: ''});
                        this.getClaimData();
                    }
                    if(error){
                        this.setState({ ...this.state, successSubmit: false, errorMsg: error.errorMessage });
                    }
                }
            );
        }catch(err){
            console.error(err);
        }
    }

    render() {

        const claimData = this.props.claims.detailInpatientData;
        const loading = this.props.claims.detailInpatientLoading;
        let allowEdit = false;

        if (loading) return "Loading";
        if (!claimData) return "Data Not Found";
        if (claimData) {
            let isAdminOperation = CommonUtility.haveUserType(USER_TYPE.SYS_ADMIN, this.props.user) && CommonUtility.haveRoles([USER_ROLES.ADMIN_OPERATION], this.props.user);
            let isStatusProcessing = claimData.claimStatus === CLAIM_STATUS.PROCESSING ? true : false;
            allowEdit = isAdminOperation && isStatusProcessing;
        }
        
        return (

            <Formik
                initialValues={{
                    _id: claimData._id,
                    claimRetry: claimData.claimRetry,
                    claimStatus: claimData.claimStatus
                }}
                validateOnChange={false}
                validateOnBlur={false}
                onSubmit={this.editClaim.bind(this)}
                render={({
                    values,
                    errors,
                    status,
                    touched,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue
                }) => (
                    <Form>
                        <Segment>
                            <Grid container columns={2}>
                                <Grid.Column width={16}>
                                    <Divider horizontal> <Header as="h3">System Data</Header> </Divider>
                                </Grid.Column>

                                <Grid.Column>
                                    <Field name="claimRetry" label="Claim Retry" secondaryLabel="" component={FormsInputsNumber} disabled={true} />
                                </Grid.Column>
                                <Grid.Column>
                                    <Field name="claimStatus" label="Status" secondaryLabel="" component={FormsInputsText} disabled={true} />
                                </Grid.Column>

                                {allowEdit &&
                                    <Grid.Column width={16}>
                                        <Button loading={isSubmitting} type="submit" primary disabled={isSubmitting} fluid size="big">
                                            Reprocess
                                        </Button>
                                    </Grid.Column>
                                }

                                <Grid.Column width={16}>
                                    {this.renderSubmitResult()}
                                </Grid.Column>
                            </Grid>

                            <br />
                            <br />
                            <br />
                        </Segment>
                    </Form>
                    )}
            >

            </Formik>



        )

    }

}

const mapStateToProps = (state) => {
    return {
        user: state.user.user,
        claims: state.systemAdminClaims,
        claimOptions: state.claimOptions,
        appConfig: state.appConfig,
    };
}

export default connect(mapStateToProps, {
    getDetailInpatientClaimBySysAdmin,
    getClaimOptions,
    getBankOptions,
    editInpatientClaimBySysAdmin
})(withRouter(InpatientViewImbursement))